/* TRYBUY: product-page-only code. Existing product behavior is preserved.
 * Loaded by main-product.liquid, never by homepage/collection/blog templates. */
(function(){
'use strict';
window.tbInitProduct=function(services){
  var root=document.querySelector('[data-pdp]');
  if(!services||!root||!window.__tbProduct||root.__tbPdpInitialized)return;
  root.__tbPdpInitialized=true;
  var $=services.select,$$=services.selectAll;
  var addToCart=services.addToCart,openCart=services.openCart,showToast=services.showToast;
/* ================= PRODUCT PAGE ================= */
function hashStr(s){var h=0;for(var i=0;i<s.length;i++)h=(h*31+s.charCodeAt(i))%100000;return h}
function starStr(r){var f=Math.round(r);return "\u2605\u2605\u2605\u2605\u2605".slice(0,f)+"\u2606\u2606\u2606\u2606\u2606".slice(0,5-f)}
var COLOR_MAP={'off-white':'#ece8df','navy blue':'#1f2a44','light blue':'#7fa8d8','dark grey':'#3a3c40','light grey':'#b9bbbe','dark green':'#1f4d2e','light green':'#7da06a','olive green':'#5b5e2a','olive brown':'#5d5230','teal green':'#1f7a72','pastel pink':'#e3a7bd','dark purple':'#3f285c','dark brown':'#3d2a1d','rust brown':'#9c4a2a',charcoal:'#3a3d42',burgundy:'#5e1726',maroon:'#5c1a2b',multicolor:'#c43d63',mauve:'#9b7b8e',cream:'#e7ddc6',beige:'#d8c9a8',yellow:'#d9b53a',purple:'#5b3a7e',olive:'#5b5e2a',teal:'#1f7a72',rust:'#9c4a2a',brown:'#5a3d2b',green:'#2e6b3e',navy:'#1f2a44',blue:'#2b5fb0',grey:'#7d7f83',gray:'#7d7f83',pink:'#d96a8f',white:'#eceae3',black:'#15161a'};
function colorFromName(n){n=n.toLowerCase();var ks=Object.keys(COLOR_MAP).sort(function(a,b){return b.length-a.length});for(var i=0;i<ks.length;i++)if(n.indexOf(ks[i])>-1)return{label:ks[i].replace(/(^|\s|-)\w/g,function(c){return c.toUpperCase()}),hex:COLOR_MAP[ks[i]]};return{label:'Signature',hex:'#E30613'}}
function patternFrom(n){n=n.toLowerCase();if(n.indexOf('chikankari')>-1)return'Chikankari';if(n.indexOf('embroider')>-1)return'Embroidered';if(n.indexOf('patchwork')>-1)return'Patchwork';if(n.indexOf('floral')>-1)return'Floral Print';if(n.indexOf('strip')>-1)return'Striped';if(n.indexOf('textured')>-1)return'Textured';if(n.indexOf('print')>-1)return'Printed';return'Solid'}
function specsFrom(t,k){var n=t.toLowerCase();var sleeve=n.indexOf('short sleeve')>-1?'Short Sleeve':'Full Sleeve';var collar=n.indexOf('mandarin')>-1?'Mandarin Collar':(n.indexOf('spread')>-1?'Spread Collar':(k?'Mandarin Collar':'Spread Collar'));return{'Material':k?'Cotton Blend':'100% Cotton','Fit':k?'Straight Fit':'Slim Fit','Pattern':patternFrom(t),'Sleeve':sleeve,'Collar / Neck':collar,'Occasion':k?'Festive \u00b7 Wedding':'Casual \u00b7 Daily','Wash Care':k?'Gentle hand / dry clean':'Machine wash cold','Country of Origin':'India'}}
function featuresFrom(t,k){var sp=specsFrom(t,k);return[{i:'\u2756',t:'The Fabric',d:k?'Soft, breathable cotton blend that drapes clean and stays comfortable through long events.':'Pure breathable cotton \u2014 crisp in the morning, easy all day long.'},{i:'\u2702',t:'The Cut',d:sp.Fit+' through the body with a '+sp['Collar / Neck'].toLowerCase()+' for a sharp, modern silhouette.'},{i:'\u2726',t:'The Detail',d:patternFrom(t)+(k?' work, hand-finished at our Jabalpur unit.':' styling with a clean, minimal finish.')},{i:'\u25f7',t:'Wear It For',d:k?'Weddings, festive nights, haldi and every celebration in between.':'Work, weekends and dinners \u2014 it layers effortlessly.'},{i:'\u21ba',t:'Easy Care',d:sp['Wash Care']+'. Built to hold its colour and shape, wash after wash.'},{i:'\u25c6',t:'Made In-House',d:'Designed, cut and stitched by us in Jabalpur, India \u2014 since 2018.'}]}
function reviewsSample(t){var names=['Aarav S.','Rohan M.','Karthik R.','Vikram P.','Aditya N.','Siddharth J.','Nikhil B.','Arjun K.'];var q=['Fabric quality is genuinely premium for the price. Fit was spot on.','Got so many compliments \u2014 looks exactly like the pictures.','Stitching and finish are top class. Will be ordering more.','Perfect for the wedding season and comfortable all day.','Delivery was quick and the packaging felt premium.','Colour is rich and true to the photos. Highly recommend.'];var h=hashStr(t),o=[];for(var i=0;i<3;i++)o.push({name:names[(h+i*3)%names.length],q:q[(h+i*2)%q.length],r:i===2?4:5});return o}

function initPDP(){
  var pdp=$("[data-pdp]");if(!pdp||!window.__tbProduct)return;
  var P=window.__tbProduct,k=!!P.isKurta,t=P.title;
  var h=hashStr(t);
  var sampleRating=(4.6+(h%4)/10).toFixed(1);
  var rate=P.reviewMeta>0?P.reviewMeta:sampleRating;
  var rcount=P.reviewCount>0?P.reviewCount:(40+h%160);
  // shade
  var col=colorFromName(t);var sw=$("#pdpSwatch");if(sw){sw.style.background=col.hex;}var sn=$("#pdpShadeName");if(sn)sn.textContent=col.label;
  // rate row
  var rr=$("#pdpRate");if(rr)rr.innerHTML='<span class="stars" style="color:var(--red);font-size:14px">'+starStr(rate)+'</span> '+rate+' / 5 <a onclick="document.getElementById(\'pdpReviews\').scrollIntoView({behavior:\'smooth\'})" style="color:var(--red);text-decoration:underline;cursor:pointer">('+rcount+' reviews)</a>';
  // social
  var soc=$("#pdpSocial");if(soc)soc.innerHTML='<span class="eye">\u25cf</span> '+(12+h%30)+' people viewing now \u00b7 '+(40+h%120)+' sold this week';
  // features + specs
  var featureData=featuresFrom(t,k);
  var fg=$("#pdpFeatures");
  if(fg)fg.innerHTML=featureData.map(function(f,i){
    return '<div class="feat" data-feature-index="'+i+'"><div class="i">'+f.i+'</div><h5>'+f.t+'</h5><p>'+f.d+'</p></div>'
  }).join("");
  var sp=specsFrom(t,k),se=$("#pdpSpec");
  if(se)se.innerHTML=Object.keys(sp).map(function(kk){
    return '<div class="row"><span class="k">'+kk+'</span><span class="v">'+sp[kk]+'</span></div>'
  }).join("");
  if(window.matchMedia("(min-width: 990px)").matches){
    var featureCards=$$("#pdpFeatures .feat");
    function illuminateFeature(card){
      featureCards.forEach(function(item){
        var active=item===card;
        item.classList.toggle("is-active",active);
        item.setAttribute("aria-pressed",active?"true":"false")
      })
    }
    featureCards.forEach(function(card){
      card.setAttribute("role","button");
      card.setAttribute("tabindex","0");
      card.setAttribute("aria-pressed","false");
      card.addEventListener("click",function(){illuminateFeature(card)});
      card.addEventListener("keydown",function(e){
        if(e.key==="Enter"||e.key===" "){
          e.preventDefault();
          illuminateFeature(card)
        }
      })
    })
  }
  // reviews
  var rb=$("#revBig");if(rb)rb.textContent=rate;var rs=$("#revStars");if(rs)rs.textContent=starStr(rate);var rc=$("#revCount");if(rc)rc.textContent="Based on "+rcount+" reviews";
  var dist=[78,15,4,2,1],rbar=$("#revBars");if(rbar)rbar.innerHTML=[5,4,3,2,1].map(function(s,i){return '<div class="rev-bar"><span>'+s+'\u2605</span><span class="track"><i data-w="'+dist[i]+'"></i></span><span>'+dist[i]+'%</span></div>'}).join("");
  var rev=$("#pdpReviews");if(rev)rev.innerHTML=reviewsSample(t).map(function(rv){return '<div class="rev-card"><div class="stars">'+starStr(rv.r)+'</div><p class="q">\u201c'+rv.q+'\u201d</p><div class="who">'+rv.name+'<span>\u2713 Verified buyer</span></div></div>'}).join("");
  // reveal observer
  var ro=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting)en.target.classList.add("in")})},{threshold:.12});
  $$("#pdp .feat,#pdp .love,#pdp .rev-card,.pdp .feat,.pdp .love,.pdp .rev-card").forEach(function(el){ro.observe(el)});
  // animate stock + review bars
  setTimeout(function(){var bar=$("#pdpStockBar");if(bar)bar.style.width=Math.max(14,bar.dataset.pct||40)+"%";$$("#revBars .track i").forEach(function(i){i.style.width=i.dataset.w+"%"})},420);
  // variant selection
  var idInput=$("[data-variant-id]"),priceEls=$$("[data-price-display]");
  function setVariant(id,price){if(idInput)idInput.value=id;if(price)priceEls.forEach(function(p){p.textContent=price});$$("[data-variant]").forEach(function(b){b.classList.toggle("sel",b.dataset.variant===id)});$$("[data-stvariant]").forEach(function(b){b.classList.toggle("sel",b.dataset.stvariant===id)});var w=$("[data-form-warn]");if(w)w.classList.remove("show")}
  $$("[data-variant]").forEach(function(b){b.addEventListener("click",function(){if(b.disabled)return;setVariant(b.dataset.variant,b.dataset.price)})});
  $$("[data-stvariant]").forEach(function(b){b.addEventListener("click",function(){if(b.disabled)return;setVariant(b.dataset.stvariant)})});
  // add to cart (all [data-atc])
  $$("[data-atc]").forEach(function(b){b.addEventListener("click",function(e){e.preventDefault();if(!idInput||!idInput.value){var w=$("[data-form-warn]");if(w){w.classList.add("show");w.scrollIntoView({behavior:"smooth",block:"center"})}return}addToCart(idInput.value,1).then(function(){openCart();showToast("Added to bag")})})});
  // thumbnails
  $$("#pdpThumbs button").forEach(function(tb){tb.addEventListener("click",function(){$$("#pdpThumbs button").forEach(function(x){x.classList.remove("on")});tb.classList.add("on");var st=$("#pdpStage");if(st){st.style.opacity="0";setTimeout(function(){st.src=tb.dataset.thumb;st.style.transition="opacity .25s";st.style.opacity="1"},120)}var c=$("#pdpCount");if(c)c.textContent=(+tb.dataset.i+1)+" / "+$$("#pdpThumbs button").length})});
  // pincode
  var pb=$("[data-pin-btn]");if(pb)pb.addEventListener("click",function(){var v=($("[data-pin]").value||"").replace(/\D/g,""),el=$("[data-delivery]");if(v.length!==6){el.style.display="block";el.style.color="var(--red)";el.textContent="Enter a valid 6-digit pincode.";return}var d=new Date();d.setDate(d.getDate()+4);el.style.display="block";el.style.color="#4caf50";el.textContent="\u2713 Delivered by "+d.toLocaleDateString("en-IN",{weekday:"short",day:"numeric",month:"short"})+" \u00b7 COD available"});
  // sticky bar
  var sticky=$("#pdpSticky"),cta=$("#pdpCtaRow");
  if(sticky&&cta){var so=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting)sticky.classList.remove("show");else sticky.classList.add("show")})},{threshold:0});so.observe(cta)}
}




function initPdpReferenceTabs(){
  var root=document.querySelector("[data-pdp-tabs]");
  if(!root)return;
  var tabs=Array.prototype.slice.call(root.querySelectorAll("[data-pdp-tab]"));
  var panels=Array.prototype.slice.call(root.querySelectorAll("[data-pdp-panel]"));
  function activate(name){
    tabs.forEach(function(tab){
      var active=tab.getAttribute("data-pdp-tab")===name;
      tab.classList.toggle("is-active",active);
      tab.setAttribute("aria-selected",active?"true":"false")
    });
    panels.forEach(function(panel){
      var active=panel.getAttribute("data-pdp-panel")===name;
      panel.classList.toggle("is-active",active);
      panel.hidden=!active
    })
  }
  tabs.forEach(function(tab){
    tab.addEventListener("click",function(){activate(tab.getAttribute("data-pdp-tab"))})
  })
}

function initVisual3D(){
  var root=document.querySelector("[data-pdp-visual3d]");
  if(!root)return;
  if("IntersectionObserver" in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){root.classList.add("is-in");io.disconnect()}
      })
    },{threshold:.12});
    io.observe(root)
  }else{root.classList.add("is-in")}
  var stage=root.querySelector("[data-3d-stage]");
  var tilt=root.querySelector("[data-3d-tilt]");
  var ring=root.querySelector("[data-3d-ring]");
  var toggle=root.querySelector("[data-3d-toggle]");
  var reduceMotion=window.matchMedia("(prefers-reduced-motion: reduce)");
  var dragging=false,startX=0,baseRotation=0,currentRotation=0;
  function ringRotation(){
    if(!ring)return currentRotation;
    try{
      var tr=window.getComputedStyle(ring).transform;
      if(!tr||tr==="none")return currentRotation;
      var M=window.DOMMatrixReadOnly||window.WebKitCSSMatrix;
      if(!M)return currentRotation;
      var m=new M(tr);
      return Math.atan2(m.m13,m.m11)*180/Math.PI
    }catch(e){return currentRotation}
  }
  if(stage&&tilt){
    stage.addEventListener("pointermove",function(e){
      if(reduceMotion.matches||dragging)return;
      var r=stage.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-.5;
      var y=(e.clientY-r.top)/r.height-.5;
      tilt.style.transform="rotateX("+(-y*6).toFixed(2)+"deg) rotateY("+(x*9).toFixed(2)+"deg) translateZ(6px)"
    });
    stage.addEventListener("pointerleave",function(){
      if(!dragging)tilt.style.transform=""
    })
  }
  if(stage&&ring){
    stage.addEventListener("pointerdown",function(e){
      if(e.pointerType==="mouse"&&e.button!==0)return;
      dragging=true;
      startX=e.clientX;
      baseRotation=ringRotation();
      currentRotation=baseRotation;
      stage.classList.add("is-dragging","is-paused");
      ring.style.animation="none";
      ring.style.transform="rotateY("+baseRotation+"deg)";
      try{stage.setPointerCapture(e.pointerId)}catch(err){}
    });
    stage.addEventListener("pointermove",function(e){
      if(!dragging)return;
      currentRotation=baseRotation+(e.clientX-startX)*.5;
      ring.style.transform="rotateY("+currentRotation+"deg)"
    });
    function stopDrag(e){
      if(!dragging)return;
      dragging=false;
      stage.classList.remove("is-dragging");
      try{stage.releasePointerCapture(e.pointerId)}catch(err){}
    }
    stage.addEventListener("pointerup",stopDrag);
    stage.addEventListener("pointercancel",stopDrag)
  }
  if(stage&&toggle){
    toggle.addEventListener("click",function(){
      var paused=stage.classList.contains("is-paused");
      if(paused){
        stage.classList.remove("is-paused");
        if(ring){ring.style.animation="";ring.style.transform=""}
      }else{
        stage.classList.add("is-paused")
      }
      var nowPaused=stage.classList.contains("is-paused");
      toggle.setAttribute("aria-label",nowPaused?"Play product motion":"Pause product motion");
      var icon=toggle.querySelector("span");
      if(icon)icon.textContent=nowPaused?"▶":"Ⅱ"
    })
  }
}

  initPDP();
  initPdpReferenceTabs();
  initVisual3D();
};
if(window.tbProductServices)window.tbInitProduct(window.tbProductServices);
})();
